import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {RiplayUmumComponent} from "./riplay-umum.component";

const routes: Routes = [
  {
    path: 'riplay',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: RiplayUmumComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RiplayUmumRoutingModule { }
